import Resource from "utils/resourcesUtil";

export function makePayment(paymentDetails) {
  return Resource.postCard(
    "card-service/api/v1/customers/current/account/payments",
    paymentDetails
  ).then(response => {
    return response;
  });
}
/**
 * @return {Promise}
 */
export function getCardAccount() {
  return Resource.getCard("card-service/api/v1/customers/current/account", {}).then(
    response => {
      return response.data;
    }
  );
}

/**
 * @return {Promise}
 */
export function getDefaultPaymentMethod() {
  return Resource.getCard("card-service/api/v1/customers/current/payment-methods/default", {}).then(
    response => {
      return response.data;
    }
  );
}

export function getNewData() {
  return Resource.getCard("card-service/api/v1/customers/current/sunbit-card", {}).then(
    response => {
      return response.data;
    }
  );
}

export function getStatement() {
  return Resource.getCard("card-service/api/v1/customers/current/account/statements/last",
    {}
  ).then(response => {
    return response.data;
  });
}

export function getTransactionsByDate( data ) { // currently returning if there is a file
  return Resource.getCard(`card-bnpl-service/api/v1/customer/transactions/statement-transactions-by-closing-date?closingDate=${data}`,
    {}).then(response => {
    return response.data; //{ "statement": ... , "statementTransactions": [...] }
  });
}

export function getPendingAndCurrentTransactions( ) {
  return Resource.getCard(
    "card-service/api/v1/customers/current/account/filtered-authorizations-and-current-transactions",
    {}).then(response => {
    return response.data;
  });
}

export function getDdTransactionsList() { // return the dates array for the dropdown
  return Resource.getCard("card-bnpl-service/api/v1/customer/statements/dates", {}).then(response => {
    return response.data;
  });
}

export function getBalance() {
  return Resource.getCard(
    "card-service/api/v1/customers/current/account/balance",
    {}
  ).then(response => {
    return response.data;
  });
}

export function setAutoPay(enabled) {
  return Resource.putCard(
    "card-service/api/v1/customers/current/account/auto-pay",
    {enabled}
  ).then(response => {
    return response.data;
  });
}

export function addPaymentMethod(paymentProfile) {
  return Resource.postCard(
    "card-service/api/v1/customers/current/account/payment-profiles",
    paymentProfile
  ).then(response => {
    return response.data;
  });
}

export function updateIncomeAndHousing(atpDetails) {
  return Resource.postCard(`card-service/api/v1/customers/current/atp`,
    atpDetails
  ).then(response => response.data);

}

export function fetchAtpDetails() {
  return Resource.getCard(`card-service/api/v1/customers/current/atp/last`
  ).then(response => response.data);
}




// WEBPACK FOOTER //
// ./src/services/api/card.js